export { default } from './PhoningIcon';
